
export enum ExamSectionEnum {
    MCQ = "MCQ",
    VSA = "VSA",
    LA = "LA",
    SA = "SA",
    CS = "CS"
}